import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('profile', 'edit-user', ['CLEAR']);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'profiles',
  type: 'put',
  slug: [
    {
      type: 'payload',
      selector: ['id'],
    },
  ],
});

const requestReducer = createReqReducer(consts);

const clear = state => ({
  ...state,
  succeed: null,
  error: null,
  rejected: null,
});

export default (state, action) => {
  const { type } = action;

  switch (type) {
    case consts.CLEAR:
      return clear(state);

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/edit-user.js